var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { GmapsInterfaceComponent } from '../common-theme/gmaps/gmaps-interface/gmaps-interface.component';
var InterfaceComponent = /** @class */ (function (_super) {
    __extends(InterfaceComponent, _super);
    function InterfaceComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return InterfaceComponent;
}(GmapsInterfaceComponent));
export { InterfaceComponent };



// WEBPACK FOOTER //
// ./src/app/localisation/interface.component.ts.pre-build-optimizer.js